export const APP_PAGE_PATH = 'app';
export const MEMBER_PAGE_PATH = 'member';
export const PROFILE_ROUTE_PATH = 'profile';
export const MEMBER_CARD_ROUTE_PATH = 'member-card';
